// Manuel Sipariş Ekle (WMS) penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'wms.createOrder';

export const wmsCreateOrderGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Havuza elle sipariş nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Telefonla ya da başka yoldan gelen bir siparişi Sipariş Havuzu\'na elle eklersiniz. Sipariş "Bekleyen" durumunda havuza düşer ve diğer siparişler gibi iş emrine bağlanır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Manuel Sipariş Ekle'),
    body: t(`${G}.regions.body`, 'Müşteri, kargo ve ürünler'),
    footer: t(`${G}.regions.footer`, 'İptal / Sipariş Oluştur'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Müşteri ve sipariş bilgileri'),
      text: t(`${G}.s1.text`, 'Müşteri Adı zorunludur. Sipariş No boş bırakılırsa otomatik verilir. Telefon, Adres ve Kargo Yöntemi isteğe bağlıdır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Kaynak ve öncelik'),
      text: t(`${G}.s2.text`, '"Sipariş Kaynağı" siparişin hangi kanala ait sayılacağını belirler (E-Ticaret, Trendyol, Hepsiburada, N11, Pazarama, PttAVM); havuzdaki kaynak düğmeleri buna göre süzer. "Öncelik" Normal, Yüksek veya Acil olabilir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Ürün ve adet ekleyin'),
      text: t(`${G}.s3.text`, '"Ürün Ekle" yeni satır açar. Ürün kutusuna en az 2 harf yazarak ad, barkod veya stok koduyla arayın ya da açılan kategori listesinden bir kategoriye tıklayıp ürünü seçin. "Adet" girin; gereksiz satırı silin. En az bir ürün eklenmelidir.'),
      tips: [
        t(`${G}.s3.tip1`, '"Tip" toplam adede göre kendiliğinden belirlenir: toplam 1 adet ise Tekli, fazlaysa Çoklu.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Siparişi oluşturun'),
      text: t(`${G}.s4.text`, '"Sipariş Oluştur" siparişi "Bekleyen" durumunda havuza ekler. Sipariş oluşturmak stok miktarını değiştirmez; stok, ürün toplama sırasında raftan düşer.'),
    },
  ],
});
